export default "__VITE_ASSET__BJhqAElR__"